export default {
    name: 'Navbar',
    data() {
      return {
        isScrolled: false,
        isMenuActive: false
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll() {
        this.isScrolled = window.scrollY > 50;
      },
      toggleMenu() {
        this.isMenuActive = !this.isMenuActive;
        document.body.style.overflow = this.isMenuActive ? 'hidden' : '';
      },
      closeMenu() {
        this.isMenuActive = false;
        document.body.style.overflow = '';
      }
    }
  }